/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Metrics_Font_Size_HelpInputs */



/**
* | output |
* | --- |
* | "Set the font size (in pixels) of the metrics shown on each event in the editor list." |
*
* @param {Options_Metrics_Font_Size_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_metrics_font_size_help = /** @type {((inputs?: Options_Metrics_Font_Size_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Metrics_Font_Size_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Set the font size (in pixels) of the metrics shown on each event in the editor list.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Set the font size (in pixels) of the metrics shown on each event in the editor list.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Set the font size (in pixels) of the metrics shown on each event in the editor list.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Set the font size (in pixels) of the metrics shown on each event in the editor list.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Set the font size (in pixels) of the metrics shown on each event in the editor list.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Set the font size (in pixels) of the metrics shown on each event in the editor list.")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Set the font size (in pixels) of the metrics shown on each event in the editor list.")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Set the font size (in pixels) of the metrics shown on each event in the editor list.")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Set the font size (in pixels) of the metrics shown on each event in the editor list.")
	return /** @type {LocalizedString} */ ("Set the font size (in pixels) of the metrics shown on each event in the editor list.")
});